import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-door-left-lock-d',
  templateUrl: './door-left-lock-d.component.html',
  styleUrls: ['./door-left-lock-d.component.scss']
})
export class DoorLeftLockDComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
